@switch (step) {
  @case (STEPS.CREATE) {
    <saving-plans-create
      (noWalletWarningClick)="handleNoWallet()"
      (goNext)="step = STEPS.CONFIRM"
      [assets]="facade.multiSavingsPlansAssets$ | async"
    />
  }
  @case (STEPS.CONFIRM) {
    <saving-plans-confirm (goBack)="goBack()" (confirm)="facade.createSavingsPlans()" />
  }
}
